module.exports = __webpack_public_path__ + "img/coctail-2.37e3cca6.png";